import React, { useState, useEffect } from 'react';
import ListItem from './ListItem.js';

export default function ListView({ setBatch, batchList, curUser }) {
  const [archiveDisplayed, setArchiveDisplayed] = useState(false);
  const [fullList, setFullList] = useState([]);
  const [archiveList, setArchiveList] = useState([]);
  const [displayList, setDisplayList] = useState([]);

  // when archive button is clicked, toggle the state of archiveDisplayed and change the display list array based on archived item array
  const toggleArchive = () => {
    let newViewStatus = !archiveDisplayed;
    let updatedList = [];
    if (newViewStatus) {
      updatedList = archiveList;
    } else {
      updatedList = fullList.filter((item) => !archiveList.includes(item));
    }
    setDisplayList(updatedList);
    setArchiveDisplayed(!archiveDisplayed);
  };

  // When the list item is archived, update the archive list and display list
  const archiveItem = (batch_id) => {
    let updatedList = [];
    let newArchiveList = archiveList;
    // update archive list
    fullList.map((item) => {
      if (item.batch_id == batch_id) {
        newArchiveList.push(item);
      }
    });
    // update display list
    if (archiveDisplayed) {
      updatedList = newArchiveList;
    } else {
      updatedList = fullList.filter((item) => !newArchiveList.includes(item));
    }
    setArchiveList(newArchiveList);
    setDisplayList(updatedList);
  };

  // When the list item is unarchived, update the archive list
  const unarchiveItem = (batch_id) => {
    let updatedList = [];
    let newArchiveList = archiveList.filter(
      (item) => item.batch_id !== batch_id
    );
    // update display list
    if (archiveDisplayed) {
      updatedList = newArchiveList;
    } else {
      updatedList = fullList.filter((item) => !newArchiveList.includes(item));
    }
    setArchiveList(newArchiveList);
    setDisplayList(updatedList);
  };

  // create array of all batch items, and array of archived items, use those to create display list array
  const createLists = () => {
    let renderedList = [];
    let fullList = [];
    let archiveList = [];
    let displayList = [];
    for (const [key, value] of Object.entries(batchList)) {
      for (const [key, value] of Object.entries(value)) {
        renderedList.push(value);
      }
    }
    fullList = renderedList.filter((item) => true);
    archiveList = renderedList.filter((item) => item.archived);
    displayList = fullList.filter((item) => !archiveList.includes(item));
    setFullList(fullList);
    setArchiveList(archiveList);
    setDisplayList(displayList);
  };

  useEffect(() => {
    createLists();
  }, [batchList]);

  return (
    <div className="container u--margin-top-35">
      <CreateUTMButtons
        createBatch={setBatch}
        curUser={curUser}
        toggleArchive={toggleArchive}
        archiveDisplayed={archiveDisplayed}
      />
      <ListHeaders />
      {displayList.map((listItem) => {
        // check if listItem is on archiveList. If so, pass archiveStatus as true
        if (archiveList.includes(listItem)) {
          return (
            <ListItem
              key={listItem.batch_id}
              item={listItem}
              editUTMs={setBatch}
              archiveStatus={true}
              archiveItem={archiveItem}
              unarchiveItem={unarchiveItem}
            />
          );
        } else {
          return (
            <ListItem
              key={listItem.batch_id}
              item={listItem}
              editUTMs={setBatch}
              archiveStatus={false}
              archiveItem={archiveItem}
              unarchiveItem={unarchiveItem}
            />
          );
        }
      })}
    </div>
  );
}

function CreateUTMButtons({
  createBatch,
  curUser,
  toggleArchive,
  archiveDisplayed
}) {
  const newBatch = {
    batch_id: '',
    user: curUser,
    organization: 'User Org',
    groupName: '',
    utm_codes: []
  };

  return (
    <div className="grid grid--between">
      <div className="grid__col-xs-12 grid__col-sm-6 grid__col-md-4 grid__col-lg-3">
        <p>
          <button
            className="btn btn--blue"
            onClick={() => createBatch(newBatch)}
          >
            <span className="btn__content">
              <span className="btn__text">Create New UTM</span>
            </span>
          </button>
        </p>
      </div>
      <div className="grid__col-xs-12 grid__col-sm-6 grid__col-md-4 grid__col-lg-3">
        <p>
          <button
            className="btn btn--blue"
            onClick={() => {
              toggleArchive();
            }}
          >
            <span className="btn__content">
              <span className="btn__text">
                {archiveDisplayed ? 'Hide Archived' : 'Show Archived'}
              </span>
            </span>
          </button>
        </p>
      </div>
    </div>
  );
}

function ListHeaders() {
  return (
    <div className="u--margin-auto">
      <div className="grid utm__list-headers">
        <div className="grid__col-lg-3">Date</div>
        <div className="grid__col-lg-2">User</div>
        <div className="grid__col-lg-1">Org</div>
        <div className="grid__col-lg-3">Group Name</div>
        <div className="grid__col-lg-1">#UTMs</div>
        <div className="grid__col-lg-2">Actions</div>
      </div>
    </div>
  );
}
